/** Optro Zendesk Help Center article the Docs link deep-links to (via SSO). */
export const HELP_CENTER_ARTICLE_URL =
  "https://support.soxhub.com/hc/en-us/articles/51131503971355-About-Autonomous-Testing-Midship-with-Optro";

/**
 * Docs sidebar link target. The Optro Help Center is gated, so Docs routes
 * through the Zendesk SSO redirect page (which signs the user in) with
 * `return_to` deep-linking to the article; the backend falls back to the Help
 * Center home if the article URL isn't valid.
 */
export const DOCS_HELP_CENTER_HREF = `/support/zendesk?return_to=${encodeURIComponent(
  HELP_CENTER_ARTICLE_URL,
)}`;
